(function () {

  'use strict';

  eclipseApp.directive('rgCartSummaryBox', ['$rootScope', 'cartManager', function ($rootScope, cartManager) {
    return {
      restrict: 'E',
      scope: false,
      replace: true,
      templateUrl: 'modules/core/views/cart-summary.html',
      controller: 'cartCtrl'
    };
  }]);

})();

